import { RootState } from "domain/store";

export const selectTutorials = (state: RootState) => {
  return state.tutorials.tutorials;
};

export const selectTutorial = (state: RootState) => {
  return state.tutorials.tutorial;
};

export const selectTutorialsTotalCount = (state: RootState) => {
  return state.tutorials.totalCount;
};

export const selectRandomTutorial = (state: RootState) => {
  return state.tutorials.randomTutorial;
};
